module.exports = __webpack_public_path__ + "static/soundline-logo-ef56e10c578d754d0f60c4be9c5d5a03.png";